import EmployeeInfoWorkExperienceComponent from "../components/EmployeeInfoWorkExperience";
import useEmployeeWorkExperience from "../hooks/useEmployeeWorkExperience";

function EmployeeInfoWorkExperience(props) {
  const useEmployeeWorkExperienceProps = useEmployeeWorkExperience();
  return (
    <EmployeeInfoWorkExperienceComponent {...useEmployeeWorkExperienceProps} {...props} />
  );
}

export default EmployeeInfoWorkExperience;
